import {GridSetting} from '@hconnect/uikit'

export const REGULAR_SIZE: GridSetting = {
  xs: 12,
  sm: 4,
  md: 6
}

export const INPUT_FORM_FIELD_SX = {sx: {fontWeight: 500}}
